module.exports = __webpack_public_path__ + "img/wallet-payment-methods.4ef8056.png";